"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.span.withConfig({
  displayName: "OzUnderline__Wrapper",
  componentId: "sc-wrmfr-0"
})(["\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-thickness: 6px;\n  text-decoration-color: ", ";\n  /*\n  border-bottom: 6px solid ", ";\n  height: 1.1em;\n  display: inline-block;*/\n\n  &, & * {\n    box-sizing: border-box;\n  }\n"], function (props) {
  return props.variant === "silvertree" ? "#76DA9F" : function (props) {
    return props.variant === "chetwodeblue" ? "#9DACF0" // : props => props.variant === "bittersweet" ? `#fd6c6c`
    : function (props) {
      return props.variant === "white" ? "#ffffff" : function (props) {
        return props.variant === "black" ? "#000000" // : props => props.variant === "gradient" ? `linear-gradient(to right,#4AD384,#687FE2)`
        : null;
      };
    };
  };
}, function (props) {
  return props.variant === "silvertree" ? "#76DA9F" : function (props) {
    return props.variant === "chetwodeblue" ? "#9DACF0" // : props => props.variant === "bittersweet" ? `#fd6c6c`
    : function (props) {
      return props.variant === "white" ? "#ffffff" : function (props) {
        return props.variant === "black" ? "#000000" // : props => props.variant === "gradient" ? `linear-gradient(to right,#4AD384,#687FE2)`
        : null;
      };
    };
  };
});

var OzUnderline = function OzUnderline(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "silvertree" : _ref$variant,
      children = _ref.children;
  return __jsx(Wrapper, {
    variant: variant
  }, children);
};

var _default = OzUnderline;
exports.default = _default;